import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      name: 'Соответствие статусов',
      enums: {
        result: {
          OK: 'OK',
          NOTOK: 'Не корректные статусы',
          OVER: 'Излишки',
          SHORTFALL: 'Недостача',
          CODE_NOT_FOUND: 'Код не найден',
          DIFFERENT_VENDOR_DATA: 'Несоответствие КМ - Артикул',
        },
      },
      fields: {
        emails: 'Emails',
        mrkSystemStatus: 'Системный Статус',
        result: 'Результат',
        status: 'Статус',
        receivedByWarehouse: 'Получен складом',
        owner: 'Собственник',
      },
    },
  },
};
